import styled from "styled-components";

export const Card = styled.div<{ color: string; selected: boolean }>`
    width: 256px;
    height: 501px;
    border-radius: 9px;
    cursor: pointer;

    border: ${p => (p.selected ? `3px solid ${p.color}` : "3px solid transparent")};

    .inner {
        background-color: ${p => p.theme.bgFront};

        :hover {
            background-color: ${p => p.theme.upgradeModal.plans.panelHover};
        }

        border: 1px solid ${p => p.theme.borderColorLight};
        border-radius: 9px;
        width: 250px;
        height: 495px;
        .info {
            padding: 16px 22px 24px 32px;
            .type {
                color: ${p => p.color};
                font-size: 18px;
                font-weight: 800;
            }
            .cost {
                margin-top: 4px;
                display: flex;
                align-items: flex-end;
                .number {
                    color: ${p => p.color};
                    font-size: 34px;
                    font-weight: 700;
                    margin-right: 10px;
                    line-height: 32px;
                }
                .description {
                    display: flex;
                    flex-direction: column;
                    line-height: 13px;
                    .units {
                        color: ${p => p.theme.n800};
                        font-size: 11px;
                        opacity: 0.65;
                    }
                }
            }
            .muted {
                color: ${p => p.theme.n800};
                opacity: 0.65;
            }
            .bold {
                font-weight: 700;
                margin-right: 4px;
            }
            .per-user {
                display: flex;
                font-size: 11px;
                align-items: center;
                margin-top: 8px;
                .amount {
                    margin: 0px 8px 0px 4px;
                    color: ${p => p.color};
                    font-size: 19px;
                    font-weight: 700;
                    letter-spacing: -0.49px;
                }
            }
            .features {
                margin-top: 12px;
            }
        }
    }
`;
